// /app/signin — where the iPhone's https sign-in sends the grant (see utils/appSignin.js). The app's
// sign-in sheet catches this link before it loads, so normally nobody sees this page; it is here
// for a browser that renders it anyway. The one-time grant in the link is cleared from the address
// bar: it's useless without the phone's verifier, but there's no reason to keep it in history.
import { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import Logo from "../assets/icons/logo_full.png";

export default function AppSignedIn() {
  const [failed] = useState(() => new URLSearchParams(window.location.search).has("error"));

  useEffect(() => {
    try { window.history.replaceState(null, "", window.location.pathname); } catch (_) { /* cosmetic */ }
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3, bgcolor: "background.default" }}>
      <Paper elevation={0} sx={{ p: 4, maxWidth: 440, width: "100%", border: 1, borderColor: "divider", borderRadius: 3 }}>
        <Box component="img" src={Logo} alt="Assertion" sx={{ height: 28, mb: 3, display: "block" }} />
        <Typography variant="h6" sx={{ mb: 1 }}>{failed ? "Sign-in didn't finish." : "You're signed in."}</Typography>
        <Typography variant="body2" color="text.secondary">
          {failed ? "Return to the Assertion app and try again." : "Return to the Assertion app."}
        </Typography>
      </Paper>
    </Box>
  );
}
